var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-header',{attrs:{"active_item":_vm.$route.name}}),_c('router-view',{key:_vm.$router.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }